/* import __COLOCATED_TEMPLATE__ from './controls.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentPreviewControls extends Component {}
